import { ReviewVideoPlayer } from "./ReviewVideoPlayer";

/**
 * Always use ReviewVideoPlayer so private OVH/ttdata URLs are signed before
 * playback. A bare <video src> on desktop 403s and looks like the clip won't play.
 */
export function MobileReviewVideo({
  url,
  mode = "embedded",
  autoPlay = false,
  className,
  videoClassName,
}) {
  if (!url) return null;

  return (
    <ReviewVideoPlayer
      url={url}
      mode={mode}
      autoPlay={autoPlay}
      className={className}
      videoClassName={videoClassName}
    />
  );
}

export default MobileReviewVideo;
